/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaDayStatusOncallIndicator: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="dayStatusOncallIndicator" viewBox="0 0 29 8">
      <path
        d="M4 3.80853H25"
        stroke="#4D7080"
        strokeWidth="7"
        strokeLinecap="round"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaDayStatusOncallIndicator)
